import { useRef, useMemo } from 'react';
import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts';
import { Theme } from '@shape-ds/components';
import { graphOptions } from 'config/graph';

type HealthChartProps = {
  healthData: string | number;
  isGaussianLigth?: boolean;
  chartHeight?: string;
  className?: string;
};

export const HealthChart = ({
  healthData,
  isGaussianLigth,
  chartHeight,
  className = '',
}: HealthChartProps) => {
  const { t } = useTranslation();
  const theme = useTheme<Theme>();
  const gaussianColor = isGaussianLigth ? theme.tokens.colors.gray[2] : theme.tokens.colors.gray[3];
  const graphColor =
    Number(healthData) < 50 ? theme.tokens.colors.red[1] : theme.tokens.colors.green[1];

  const style = useRef({
    width: chartHeight ?? '100%',
    height: chartHeight || '100px',
  });

  const graphData = useMemo(
    () =>
      graphOptions({
        title: {
          text: healthData !== 'NC' ? `${Number(healthData).toFixed(0)}% ` : 'NC',
          textStyle: { color: theme.tokens.colors.gray[7], fontSize: 18, fontFamily: 'Nunito' },
          subtext: t('monitoring:summary.health'),
        },
        series: [
          {
            color: [graphColor, gaussianColor],
            data: [
              { value: Number(healthData), name: '' },
              {
                value: 100 - Number(healthData),
                name: '',
              },
            ],
          },
        ],
      }),
    [healthData],
  );
  return (
    <ReactECharts
      echarts={echarts}
      option={graphData}
      style={style.current}
      className={className}
    />
  );
};
